import { ResearchReportVM } from 'civil-status/view-models/research-report';
import { Operation } from 'shell/view-models/operation';
import { OperationObject } from 'system/utils/operation-object-to-query-string';

export const transformerReportResearch = (values: ResearchReportVM): OperationObject => {
  return {
    dataInizio: {
      value: values.dateStart ? values.dateStart.toFormat('yyyy-MM-dd') : '',
      operation: Operation.EQUALS,
    },
    dataFine: {
      value: values.dateEnd ? values.dateEnd.toFormat('yyyy-MM-dd') : '',
      operation: Operation.EQUALS,
    },
    registro: {
      value: values.idCat || '',
      operation: Operation.EQUALS,
    },
    tipoContenuto: {
      value: values.typeContent || '',
      operation: Operation.EQUALS,
    },
    codiceStato: {
      value: values.state || '',
      operation: Operation.EQUALS,
    },
    codiceOperatore: {
      value: values.codOperator || '',
      operation: Operation.EQUALS,
    },
    codiceServizio: {
      value: values.service || '',
      operation: Operation.EQUALS,
    },
  };
};
